export enum TicketStatus {
  New = 'New',
  Open = 'Open',
  ClosedComplete = 'Closed Complete',
  ClosedIncomplete = 'Closed Incomplete',
  Closed = 'Closed',
  AwaitingVendor = 'Awaiting Vendor',
  Active = 'Active',
  AwaitingUser = 'Awaiting User',
  AwaitingProblem = 'Awaiting Problem',
  AwaitingInternal = 'Awaiting internal',
  Resolved = 'Resolved',
  WorkInProgress = 'Work in progress',
  ClosedSkipped = 'Closed skipped',
  Pending = 'Pending'
}

export interface TicketDTO {
  ticketNumber: string;
  shortDescription: string;
  ticketStatus: string;
  sysCreatedOn: string;
  servicePortalLink: string;
  latestComments: string;
}

export interface Ticket {
  id: string;
  title: string;
  link: string;
  serviceName: string;
  date: Date;
  status: TicketStatus;
}

export interface TicketsFiltering {
  startDate: Date;
  endDate: Date;
  statuses: TicketStatus[];
}
